'use strict';

/**
 * Ritorna il primo elemento di un array
 *
 * @param array
 * @returns {*}
 */
module.exports = function first(array) {
    return array && array[0];
};
